export const en = {
    error: 'Error',
    new: 'New',
    processing: 'Processing',
    ready: 'Ready'
};
